import { useDocumentTitle } from "~src/hooks/useDocumentTitle";
import styles from "./index.module.less";

const SdkList = () => {
  useDocumentTitle("第三方SDK清单");

  return <div className={styles.container}>
    <span
      className={styles.title}
      style={{ marginTop: "20px", textAlign: "center" }}
    >
      第三方SDK清单
    </span>
    <span className={styles.paragraph} style={{ fontStyle: "italic", textAlign: "right" }}>
      发布日期：<span className={styles.word}>【2023】</span>年
      <span className={styles.word}>【07】</span>月
      <span className={styles.word}>【05】</span>日
    </span>
    <span className={styles.paragraph}>
      为保障相关功能实现与应用安全稳定运行，我们会接入由第三方提供的软件工具开发包（SDK）。我们会对第三方获取信息的SDK进行严格的安全监测，以保护个人信息和数据安全。
    </span>
    <span className={styles.paragraph}>
      请注意，第三方 SDK 收集个人信息的类型可能会因其版本升级、规则调整等原因发生变化，具体请以其公示的官方说明为准。
    </span>
    <span className={styles.paragraph}>
      1.微信开放平台<br />
      第三方名称：深圳市腾讯系统有限公司<br />
      收集用途/目的：提供微信授权登录、微信分享和微信支付服务等功能<br />
      收集个人信息类型：终端设备唯一标识符（Android_ID、IDFV、OAID）、操作系统版本、设备品牌及型号、设备配置、运营商类型、应用信息（应用名、应用版本号)、粗略位置信息、应用安装列表、剪贴板信息、网络IP地址、订单金额<br />
      隐私政策链接：
      <a href="https://support.weixin.qq.com/cgi-bin/mmsupportacctnodeweb-bin/pages/RYiYJkLOrQwu0nb8" target="_blank">https://support.weixin.qq.com/cgi-bin/mmsupportacctnodeweb-bin/pages/RYiYJkLOrQwu0nb8</a>
    </span>
    <span className={styles.paragraph}>
      2.神策分析 SDK<br />
      第三方名称：神策网络科技（北京）有限公司<br />
      收集用途/目的：提供统计分析数据功能<br />
      收集个人信息：设备信息（包括IMEI、Android ID、IDFA、IDFV、OAID、UUID、Mac地址、IMSI信息等）、日志信息（包括IP地址、访问服务的URL、浏览器类型和使用语言等）、位置信息、唯一应用程序编号。<br />
      隐私政策链接：<a href="https://www.sensorsdata.cn/market/privacy_policy.html" target="_blank">https://www.sensorsdata.cn/market/privacy_policy.html</a>
    </span>
    <span className={styles.paragraph}>
      3.高德开放平台定位SDK<br />
      第三方名称：高德软件有限公司<br />
      收集用途/目的：为了向用户提供定位服务<br />
      收集个人信息：位置信息（经纬度、精确位置、粗略位置）【通过IP 地址、GNSS信息、WiFi状态、WiFi参数、WiFi列表、SSID、BSSID、基站信息、信号强度的信息、蓝牙信息、传感器信息（矢量、加速度、压力）、设备信号强度信息获取、外部储存目录】、设备标识信息（IMEI、IDFA、IDFV、Android ID、MEID、MAC地址、OAID、IMSI、ICCID、硬件序列号）、当前应用信息（应用名、应用版本号）、设备参数及系统信息（系统属性、设备型号、操作系统、运营商信息）。<br />
      隐私权政策链接：<a href="https://lbs.amap.com/pages/privacy/" target="_blank">https://lbs.amap.com/pages/privacy/</a>
    </span>
    <span className={styles.paragraph}>
      4.高德开放平台地图SDK<br />
      第三方名称：高德软件有限公司<br />
      收集用途/目的：为了实现地图展示、定位、搜索等服务<br />
      收集个人信息：位置信息（经纬度、精确位置、粗略位置）【通过IP 地址、GNSS信息、WiFi状态、WiFi参数、WiFi列表、SSID、BSSID、基站信息、信号强度的信息、蓝牙信息、传感器信息（矢量、加速度、压力、方向、地磁）、设备信号强度信息获取、外部储存目录】、设备标识信息（IMEI、IDFA、IDFV、Android ID、MEID、MAC地址、OAID、IMSI、ICCID、硬件序列号）、当前应用信息（应用名、应用版本号）、设备参数及系统信息（系统属性、设备型号、操作系统、运营商信息）。<br />
      隐私权政策链接：<a href="https://lbs.amap.com/pages/privacy/" target="_blank">https://lbs.amap.com/pages/privacy/</a>
    </span>
  </div>
}
export default SdkList
